import request from '@/utils/request'

/**
 * 获取秒杀订单列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listProductSeckillOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listProductSeckillOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}